/* ===================================================================
   useCustomers() -- live customers for the signed-in client.

   Binds to GET /api/v1/customers (engine/api/v1/app.py) through the typed
   api client (src/lib/api.ts). Disabled until a Bearer rr_ token exists.
   =================================================================== */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api, type Customer, type CustomersResponse } from '../lib/api';
import { useApiToken } from './useApiToken';
import { qk } from './queryKeys';

export interface UseCustomersParams {
  limit?: number;
  /** Force-disable even if a token exists. */
  enabled?: boolean;
}

export function useCustomers(
  params: UseCustomersParams = {},
): UseQueryResult<CustomersResponse, Error> {
  const { enabled, ...query } = params;
  const hasToken = Boolean(useApiToken());

  return useQuery({
    queryKey: qk.customers(query),
    queryFn: ({ signal }) => api.listCustomers(query, signal),
    enabled: hasToken && enabled !== false,
    staleTime: 30_000,
  });
}

/* Convenience selector: just the array (or [] while loading). */
export function useCustomerList(params: UseCustomersParams = {}): Customer[] {
  return useCustomers(params).data?.customers ?? [];
}
